import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate';
import { i18n } from './services/i18n';
import commonPlugin from './plugins/commonPlugin';
import axios from 'axios';
import VueGtag from 'vue-gtag';

Vue.config.productionTip = process.env.VUE_APP_ENV === 'development';
Vue.use(Vuelidate);
Vue.use(commonPlugin);

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-117676079-1' },
  },
  router
);

/* axios default setting */
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.get['Content-Type'] = 'application/json';

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
